<template>
    <div>
        <div class="grid-container">
            <div class="grid-x" v-if="studies">
                <div class="cell">
                    <br />
                    <p class="text-right">
                        <router-link to="CreateStudy" class="button">{{labels.createNewStudy}}</router-link>
                    </p>
                </div>
                <div class="table__wrapper cell">
                    <table class="table table table--ip">
                        <caption><h2>{{labels.studiesInProgress}}</h2></caption>
                        <thead>
                            <tr>
                                <th>{{labels.date}}</th>
                                <th>{{labels.titleOfStudy}}</th>
                                <th>{{labels.author}}</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody v-if="studies.ip.length > 0">
                            <tr v-for="(study, k) of studies.ip" :key="k" :title="study.studyTitle">
                                <td>{{study.updatedDate | formatDate}}</td>
                                <td>{{trimmedTitle(study.studyTitle)}}</td>
                                <td>{{study.author}}</td>
                                <td>
                                    <a tabindex="0"
                                       @click="openStudy(study.studyId)"
                                       @keyup.enter="openStudy(study.studyId)"
                                       class="button small">{{labels.edit}}</a>

                                    <a tabindex="0"
                                       @click="deleteStudy(study.studyId)"
                                       @keyup.enter="deleteStudy(study.studyId)"
                                       class="button small alert">{{labels.delete}}</a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4" class="table__nothing">{{labels.youHaveNoStudiesInProgress}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p>&nbsp;</p>
                <div class="table__wrapper cell">
                    <table class="table table--rfa">
                        <caption><h2>{{labels.studiesSentForApproval}}</h2></caption>
                        <thead>
                            <tr>
                                <th>{{labels.date}}</th>
                                <th>{{labels.status}}</th>
                                <th>{{labels.titleOfStudy}}</th>
                                <th>{{labels.author}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="studies.rfa.length > 0">
                            <tr v-for="(study, k) of studies.rfa"
                                :key="k"
                                @click="openStudy(study.studyId)"
                                @keyup.enter="openStudy(study.studyId)"
                                tabindex="0"
                                :title="study.studyTitle">
                                <td>{{study.updatedDate | formatDate}}</td>
                                <td>{{study.status}}</td>
                                <td>{{trimmedTitle(study.studyTitle)}}</td>
                                <td>{{study.author}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="5" class="table__nothing">{{labels.youHaveNoStudiesReadyForPublication}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p>&nbsp;</p>
                <div class="sort cell">
                    <label for="sort" class="form__sort-label">{{labels.show}}</label>
                    <select name="sort" id="sort" v-model="selectedScientist" class="form__select form__select--sort">
                        <option value="all">{{labels.allResearchers}}</option>
                        <option v-for="(scientist, k) of scientists" :key="k" :value="scientist">{{scientist}}</option>
                    </select>
                </div>
                <div class="table__wrapper cell">
                    <table class="table table--icc">
                        <caption><h2>{{labels.otherStudiesOpenForComments}}</h2></caption>
                        <thead>
                            <tr>
                                <th>{{labels.date}}</th>
                                <th>{{labels.researcher}}</th>
                                <th>{{labels.titleOfStudy}}</th>
                                <th>{{labels.author}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="studies.icc.length > 0">
                            <tr v-for="(study, k) of studies.icc"
                                :key="k"
                                @click="openStudy(study.studyId)"
                                @keyup.enter="openStudy(study.studyId)"
                                tabindex="0"
                                :title="study.studyTitle"
                                v-if="selectedScientist === 'all' || study.scientist === selectedScientist">
                                <td>{{study.updatedDate | formatDate}}</td>
                                <td>{{study.scientist || '-'}}</td>
                                <td>{{trimmedTitle(study.studyTitle)}}</td>
                                <td>{{study.author}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="5" class="table__nothing">{{labels.noStudiesCanBeCommentedAtThisTime}} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="grid-x" v-else>
                <div class="cell">
                    <div class="loader__wrapper loader__wrapper--loading loader__wrapper--md">
                        <div class="loader">
                            <div class="loader__circle"></div>
                            <div class="loader__text">{{labels.loadingStudies}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { each } from 'lodash'
    export default {
        name: "myStudiesResearcher",
        data() {
            return {
                selectedScientist: 'all'
            }
        },
        methods: {
            trimmedTitle(title) {
                if (title.length > 100) {
                    title = title.slice(0, 90) + "...";
                }
                return title;
            },
            openStudy(id) {
                this.$router.push({ name: "EditStudy", query: { id: id } });
            },
            deleteStudy(id) {
                var cf = confirm(this.labels.confirmDelete)
                if (cf) {
                    this.$store.dispatch("disableStudy", { studyId: id }).then(result => {
                        this.$store.dispatch('getMyStudies');
                    });
                }
            }
        },
        computed: {
            studies() {
                return this.$store.state.myStudies;
            },
            scientists() {
                var _scientists = [];
                if (this.studies) {
                    each(this.studies.icc, function (item) {
                        if (_scientists.indexOf(item.scientist) === -1) {
                            _scientists.push(item.scientist);
                        }
                    });
                }
                return _scientists;
            },
            labels() {
                return this.$store.state.labels['pages.mypage.mystudies'] || {};
            }
        },
        mounted() {
            this.$store.dispatch('getLabels', { label: 'pages.mypage.mystudies' });
            this.$store.dispatch('getMyStudies');
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/my-pages/MyStudiesResearcher.vue